import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { useSearchParams } from '@/hooks';
import { Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
import { NSC_URN_OPERATIONS } from '@/constants';
import { useMemo } from 'react';

export default function RWAActivityPage() {
  const { ilk } = useParams();
  const [daysAgo] = useSearchParams('days_ago', '1');

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(NSC_URN_OPERATIONS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [filters]);

  const [data, error] = useApi({
    url: `/groups/rwa/ilks/${ilk}/events/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name} Activity</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {data.ilk}
              </Flex>
            </Flex>
          </EntityName>
        }>
        <HistoricTabs ilk={ilk} />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>
        <EventsTable
          ilk={ilk}
          pagination={pagination}
          sorting={sorting}
          filters={filters}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
